import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["subdomain"];
import { createMailRuOneTapCallbackModel } from '../types/api-models/auth/mailru-onetap-callback';
export function mrOAuthAuthenticate(httpApi, parameters) {
  var subdomain = parameters.subdomain,
    restParameters = _objectWithoutProperties(parameters, _excluded);
  return httpApi.fetch(createMailRuOneTapCallbackModel({
    parameters: restParameters,
    hostType: 'api'
  }), {
    subdomain: subdomain
  });
}
export { EMailRuOneTapCallbackStatus as EMROAuthAuthenticateStatus } from '../types/api-models/auth/mailru-onetap-callback';